import React from 'react'
import {Component} from 'react'
import {DateTime} from 'luxon'
import ordinal from 'ordinal'
import './event-program.scss'

export default class EventProgram extends Component {
  get date(){
    let start = DateTime.fromString( this.props.start, 'yyyy-MM-dd hh:mm:ss' )
    let end = DateTime.fromString( this.props.end, 'yyyy-MM-dd hh:mm:ss' )
    let out = start.toFormat( 'cccc, MMMM ')
    out += ordinal( start.day )
    out += start.toFormat(' (h:mm a ')
    out += end.toFormat('- h:mm a)')
    return out
  }
  render(){
    return this.props.start ?
      <div className={`${this.props.className} event-program`}>
        <div className='event-program__article'>
          <h2 className='event-program__title'>{this.props.title}</h2>
          <span className='event-program__date'>{this.date}</span>
          <div className='event-program__content' dangerouslySetInnerHTML={this.props.content} />
        </div>
        { this.props.image &&
          <div className='event-program__image'><img src={this.props.image.sizes.large} /></div>
        }
      </div> : null
  }
}
